// @ts-nocheck
import { tryOnScopeDispose } from '@vueuse/core'

export const useProduct = () => { // Cache id is used as unique string for useAsyncData
  const { $api } = useNuxtApp()
  const wishlistStore = useWishlistStore()
  const currentSize = ref() // Export as a ref, because can be overriden on product page
  const product = ref(null)
  const metaData = ref(null)
  const status: any = ref(null)

  const stopProductWatcher = watch(product, () => {
    currentSize.value = product.value.sizes.length === 1 ? product.value.sizes[0] : null
  })

  const sizes = computed(() => {
    if (product.value?.sizes?.length > 0) {
      return product.value.sizes
    }
    return false
  })

  const sizeType = computed(() => {
    return product.value?.sizeType
  })

  const liked = computed(() => {
    if (!wishlistStore.items.length === 0) { return false }
    return wishlistStore.items.find(row => {
      if (typeof row === 'object' && typeof row.product === 'object') {
        return row.product.cId === product.value.cId
      }
      if (typeof row === 'number') {
        return row === product.value.cId
      }

      return row === product.value.cId
    })
  })
  const sizesInStock = computed(() => {
    if (!product.value?.sizes) { return false }
    return product.value.sizes.filter(item => {
      return !!item.stock
    })
  })

  const allSizesAvailable = computed(() => {
    if (!product.value?.sizes) { return false }
    const available = product.value.sizes.filter(item => {
      return item.stock > 0
    })

    return available.length === sizes.value.length
  })

  const hasColorVariations = computed(() => {
    if (!product.value) { return false }
    return Object.keys(product.value.colorVariations).length > 1
  })

  const usps = computed(() => {
    if (!product.value?.details) { return false }

    return product.value.details.find(row => {
      return row.type === 'usps'
    })
  })

  const specs = computed(() => {
    if (!product.value?.details) { return false }
    return product.value.details.find(row => {
      return row.type === 'specs'
    })
  })

  const pending = computed(() => status.value === 'pending')

  const loadProduct = async productId => {
    if (isNaN(productId) || productId.length < 4 || productId.length > 6) {
      throw new Error('Product not found')
    }

    const { data, error, status: requestStatus } = await useAsyncData(`product-${productId}`, () => {
      return $api(`products/${productId}`)
    })

    if (data.value) {
      product.value = data.value?.product
      metaData.value = data.value?.metaData
    }

    if (error.value) {
      throw new Error('Product not found')
    }
    status.value = requestStatus.value
  }

  tryOnScopeDispose(() => {
    stopProductWatcher()
  })

  return { pending, specs, usps, sizes, sizeType, hasColorVariations, allSizesAvailable, sizesInStock, liked, product, currentSize, metaData, loadProduct }
}
